import React from 'react';
import '../styles/Mission.css';

const MissionVision = () => {
  return (
    <section className="mission-vision-section">
      <div className="container text-center">
        <h5 className="sub-heading">About Director</h5>
        <h2 className="main-heading">What About Us</h2>

        <div className="row mt-5 justify-content-center">
          {/* LEFT COLUMN - Ranjan Singh */}
          <div className="col-md-6 mb-4 director-card with-border">
            <div className="dot-wrapper">
              <img src="/images/quotes-dot.svg" alt="Quote Dot" className="dot-overlay" />
            </div>

            <div className="image-name-wrapper">
              <img
                src="/images/ranjan_sir_new.png"
                alt="Mr. Ranjan Singh"
                className="director-img"
              />

              <div className="name-block">
                <div className="director-name">Mr. Ranjan Singh</div>
                <div className="director-role">Founder and CEO</div>
              </div>
            </div>

            <h6 className="about-heading mt-4">About Ranjan Singh-</h6>
            <p className="about-desc">
              The Man Behind Aligned Vertical Vision – Mr. Ranjan Singh
              From his college days, Mr. Ranjan Singh dreamed of building an organization that would contribute to India’s growth. Guided by his brother Mr. Karan Singh and co-founder Ms. Iram Ansari, he founded Aligned Vertical in 2006 with a mission to deliver impactful infrastructure solutions.

              Starting with tough projects in Ladakh, his visionary leadership expanded Aligned Vertical nationwide, diversified into telecom and managed services, and established a global HQ in Kolkata.

              Known for his collaborative style, Mr. Singh fosters a culture of trust, empowerment, and shared success—growing Aligned Vertical not just in size, but in values.            </p>
          </div>

          {/* RIGHT COLUMN - Iram     */}
          <div className="col-md-6 mb-4 director-card">
            <div className="dot-wrapper">
              <img src="/images/quotes-dot.svg" alt="Quote Dot" className="dot-overlay" />
            </div>

            <div className="image-name-wrapper">
              <img
                src="/images/iram_maam.png"
                alt="Ms. Iram Ansari"
                className="director-img"
              />

              <div className="name-block">
                <div className="director-name">Ms. Iram Ansari</div>
                <div className="director-role">Founder and CTO</div>
              </div>
            </div>

            <h6 className="about-heading mt-4">About Iram Ansari-</h6>
            <p className="about-desc">
The Tech Visionary – Ms. Iram Ansari

Co-Founder and Chief Technology Officer of Aligned Vertical, has always been passionate about technology. From the early days, her curiosity and dedication set her apart as a true leader in the tech space.

She has been the driving force behind the company’s technology journey—bringing innovation, discipline, and a clear vision for growth. Known for her ability to balance work and personal life with ease, she leads by example and inspires everyone around her.

A hardworking and determined professional, Ms. Ansari believes in building not just strong technology but also strong people. Her leadership continues to motivate the Aligned Vertical team and makes her a true role model for women in technology.            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
